/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Bills/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Bills({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Bills",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Bills.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-Z2jImB6': alignSelf,'--mt-2-Z2jImB6': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z2jImB6': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z2jImB6': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z2jImB6': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z2jImB6': opacity,'--w-10-Z2jImB6': typeof width === 'number' ? `${width}px` : width,'--h-11-Z2jImB6': typeof height === 'number' ? `${height}px` : height,'--f-12-Z2jImB6': fill,'--a-7-Z2jImB6': isAnimated ? animation : "none",'--sd-8-Z2jImB6': isAnimated ? strokeDashoffset : 0,'--sd-9-Z2jImB6': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Bills.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M1.286 0C.599 0 0 .532 0 1.239v4.86c0 .707.599 1.24 1.286 1.24h9.428c.687 0 1.286-.533 1.286-1.24V1.24C12 .532 11.401 0 10.714 0H1.286zM6 2.123a1.546 1.546 0 100 3.092 1.546 1.546 0 000-3.092zM3.025 3.86a.644.644 0 11-1.29 0 .644.644 0 011.29 0zm6.595.644a.644.644 0 100-1.289.644.644 0 000 1.29zM.93 9.052c0-.355.288-.643.643-.643h8.854a.643.643 0 110 1.286H1.573a.643.643 0 01-.643-.643zm1.448 1.633a.643.643 0 100 1.286h7.244a.643.643 0 000-1.286H2.378z"
 style={{'--f-12-Z2jImB6': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}